module.exports = __webpack_public_path__ + "static/media/rulesAccepted.19966f91.svg";